@import '@pexip/components/design-tokens/variables.scss';
@import '@pexip/components/design-tokens/mixins/media-queries.scss';

.responsiveBoxWrapper {
    box-sizing: border-box;
    max-width: 368px;
    width: 100%;
}
